export default __webpack_public_path__ + "static/media/feathersjs.e5751fe0.svg";